<div *ngIf="!isNsi" class="container-fluid">
  <br />
  <alert></alert>
  <br />
  <div class="mb-3">
    <span class="icon-left text-secondary"></span>
    <a [routerLink]="['/workflowSearch']" (click)="clearCache()"> {{'WorkflowCreate.Back' | translate}}</a>
  </div>
  <h1 class="text-primary">{{'InstanceBrowser.Title' | translate}}</h1>

  <form *ngIf="hide && (isService || isAtendimento)">
    <div class="row">
      <div class="col-md-3 label_margin">
        <h3> {{'InstanceBrowser.SubscriberNumber' | translate}} </h3>
        <input type="text" numeric="9" class="form-control" id="subscriberNumber2" name="subscriberNumber2" data-testid="subscriberNumber"
               [(ngModel)]="subscriberNumber2" />
      </div>

      <div class="col-md-5 label_margin">
        <h3> {{'InstanceBrowser.SubscriberName' | translate}} </h3>
        <input type="text" class="form-control" id="subscriberName" [(ngModel)]="subscriberName" name="subscriberName" style="text-transform: uppercase;" data-testid="subscriberName" />
      </div>
      <div class="col-md-4  label_margin">

        <div class="row">
          <div class="col-md-12">
            <h3> {{'InstanceBrowser.SubscriberType' | translate}} </h3>
            <select class="custom-select" name="tipoFasePedido" [(ngModel)]="tipoSituacaoSubPedido" (ngModelChange)="TipoFasePedidoChanged()" data-testid="tipoSituacaoSubPedido">
              <default-dropdown-values></default-dropdown-values>
              <option *ngFor="let fase of tiposSituacaoSubPedido" [value]="fase.value">
                {{fase.description}}
              </option>
            </select>
          </div>

        </div>
      </div>

    </div>
    <!--SERVIÇO-->
    <div class="row">
      <div class="col-md-3 label_margin">
        <h3> {{'InstanceBrowser.ServiceCode' | translate}} </h3>
        <input type="text" numeric="9" class="form-control" id="serviceCode" name="serviceCode" data-testid="serviceCode"
               [disabled]="isService" [(ngModel)]="serviceCode" />
      </div>
      <div class="col-md-5 label_margin">
        <h3> {{'InstanceBrowser.ServiceName' | translate}} </h3>
        <input type="text" class="form-control" id="serviceName" [disabled]="isService" [(ngModel)]="serviceName" name="serviceName" data-testid="serviceName" style="text-transform: uppercase;" />
      </div>



      <div class="col-md-4 my-auto label_margin" style="padding-top: 3.0em;">
        <div class="row  col-align-input" style="justify-content: space-evenly;">
          <div class="col-sm-4 d-flex   justify-content-between">
            <label class="form-check-label" for="voluntaria" [ngClass]="{ 'disabled' : tipoDePedido === null || tipoDePedido === undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('PM') > -1 || tipoDePedido?.indexOf('CT') > -1 }" style="user-select: none;">
              {{'InstanceBrowser.Voluntaria' | translate}}
            </label>
            <input mdbCheckbox class="form-check-input text-end" type="checkbox" value="" id="voluntaria" data-testid="voluntaria" [(ngModel)]="isVoluntaria" name="voluntaria" (click)="checkClick($event)" [disabled]="tipoDePedido=== null || tipoDePedido=== undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('PEDI0020')>-1 || tipoDePedido?.indexOf('PEDI008')  > -1 || tipoDePedido?.indexOf('PEDI005') > -1 || tipoDePedido?.indexOf('PM') >= 0" />

          </div>
          <div class="col-sm-4 d-flex justify-content-between">
            <label class="form-check-label" for="obrigatoria" [ngClass]="{ 'disabled' : tipoDePedido === null || tipoDePedido === undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('PM') > -1 || tipoDePedido?.indexOf('CT') > -1 }" style="user-select: none;">
              {{'InstanceBrowser.Obrigatoria' | translate}}
            </label>
            <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="obrigatoria" data-testid="obrigatoria" [(ngModel)]="isObrig" name="obrigatoria" (click)="checkClick($event)" [disabled]="tipoDePedido=== null || tipoDePedido=== undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('PEDI0020')>-1 || tipoDePedido?.indexOf('PEDI008') > -1 || tipoDePedido?.indexOf('PEDI005') > -1 || tipoDePedido?.indexOf('PM') >= 0" />

          </div>
          <div class="col-sm-4  d-flex  justify-content-between">
            <label class="form-check-label" for="incapacidade" [ngClass]="{ 'disabled' : tipoDePedido === null || tipoDePedido === undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('PM') > -1 || tipoDePedido?.indexOf('CT') > -1 }" style="user-select: none;">
              {{'InstanceBrowser.Incapacidade' | translate}}
            </label>
            <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="incapacidade" data-testid="incapacidade" [(ngModel)]="incapacidade" name="incapacidade" [disabled]="tipoDePedido=== null || tipoDePedido=== undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('PEDI0020')>-1 || tipoDePedido?.indexOf('PEDI008') > -1 || tipoDePedido?.indexOf('PM') >= 0" />

          </div>
        </div>
        <div class="row col-align-input" style="justify-content: space-evenly;">
          <div class="col-sm-4  d-flex  justify-content-between">
            <label class="form-check-label" for="sobrevivencia" [ngClass]="{ 'disabled' : tipoDePedido === null || tipoDePedido === undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('AP') > -1 || tipoDePedido?.indexOf('CT') > -1 }" style="user-select: none;">
              {{'InstanceBrowser.Sobrevivencia' | translate}}
            </label>
            <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="sobrevivencia" data-testid="sobrevivencia" [(ngModel)]="sobrevivencia" name="sobrevivencia" [disabled]="tipoDePedido=== null || tipoDePedido=== undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('AP') > -1 || tipoDePedido?.indexOf('CT') > -1 " />

          </div>

          <div class="col-sm-4  d-flex  justify-content-between">
            <label class="form-check-label" for="subsidioPorMorte" [ngClass]="{ 'disabled' : tipoDePedido === null || tipoDePedido === undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('AP') > -1 || tipoDePedido?.indexOf('CT') > -1 }" style="user-select: none;">
              {{'InstanceBrowser.SubsidioPorMorte' | translate}}
            </label>
            <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="subsidioPorMorte" data-testid="subsidioPorMorte" [(ngModel)]="subsidioPorMorte" name="subsidioPorMorte" [disabled]="tipoDePedido=== null || tipoDePedido=== undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('AP') > -1 || tipoDePedido?.indexOf('CT') > -1 " />

          </div>
          <div class="col-sm-4  d-flex  justify-content-between">
            <label class="form-check-label" for="reembDespFuneral" [ngClass]="{ 'disabled' : tipoDePedido === null || tipoDePedido === undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('AP') > -1 || tipoDePedido?.indexOf('CT') > -1 }" style="user-select: none;">
              {{'InstanceBrowser.ReembDespFuneral' | translate}}
            </label>
            <input mdbCheckbox class="form-check-input" type="checkbox" value="" id="reembDespFuneral" data-testid="reembDespFuneral" [(ngModel)]="reembDespFuneral" name="reembDespFuneral" [disabled]="tipoDePedido=== null || tipoDePedido=== undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('AP') > -1 || tipoDePedido?.indexOf('CT') > -1" />

          </div>
        </div>
      </div>

    </div>
    <!--PEDIDO-->
    <div class="row">
      <div class="col-md-3 label_margin">
        <h3> Tipo de Pedido </h3>
        <select class="custom-select" name="tiposDePedido" [(ngModel)]="tipoDePedido" (ngModelChange)="TipoPedidoChanged()" data-testid="tiposDePedido">
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let tipPedido of tiposPedidosDropdownsValues" [value]="tipPedido.value">
            {{tipPedido.description}}
          </option>
        </select>
      </div>
      <div class="col-md-5 label_margin">
        <h3> {{'InstanceBrowser.FundamentosLegais' | translate}} </h3>
        <select class="custom-select" name="fundamentosLegais" data-testid="fundamentosLegais" [(ngModel)]="fundamentosLegais" [disabled]="tipoDePedido=== null || tipoDePedido=== undefined || tipoDePedido=== 'undefined' || tipoDePedido?.indexOf('CT') > -1 || tipoDePedido?.indexOf('PM') > -1">
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let fundamentos of filterFundamentosByTipoPedido()" [value]="fundamentos.value">
            {{fundamentos.description}}
          </option>
        </select>

      </div>
      <div class="col-md-4 label_margin">
        <div class="row">
          <h3 class="col-md-12"> {{'InstanceBrowser.InstanceStatus' | translate}} </h3>
          <div class="col-md-12">
            <select class="custom-select col-md-6" name="estadoPedidos" data-testid="estadoPedidos"
                    [(ngModel)]="tipoEstadoPedido" (change)="filterFasePedidoPorEstado($event.target.value)">
              <default-dropdown-values></default-dropdown-values>
              <option *ngFor="let estado of tiposDropdownEstaPedidoValues" [value]="estado.value">
                {{estado.description}}
              </option>
            </select>
            <select class="custom-select col-md-6" name="fasePedidos" data-testid="fasesDePedido" [(ngModel)]="tipoFasePedido" [disabled]="tipoEstadoPedido === 'undefined' || tipoEstadoPedido === undefined || tipoEstadoPedido === null">
              <default-dropdown-values></default-dropdown-values>
              <option *ngFor="let subestado of tiposFasePedidoFiltrados" [value]="subestado.value">
                {{subestado.description}}
              </option>
            </select>
          </div>


        </div>
      </div>

    </div>
    <!--DATAS-->
    <div class="row">

      <!-- Data de Início do Pedido -->
      <div class="col-xl-4 col-md-6 label_margin">
        <h3> {{'InstanceBrowser.WorkflowStartDate' | translate}} </h3>
        <div class="row">
          <div class="col datepicker-box">
            <div class="form-group">
              <div class="input-group">
                <div style="padding-right:5px; padding-top:10px;">
                  <label for="workflowStartDateIni"> De </label>
                </div>
                <input #dpWorkflowStartDate="bsDatepicker" bsDatepicker type="text"
                       class="form-control DatepickerCustomClasse"
                       [clearRelated]="{model : this, propsToReset : ['workflowStartDateFim']}"
                       [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                       [(ngModel)]="workflowStartDateIni"
                       name="workflowStartDateIni" placeholder=" {{'Placeholders.Generic.DateFormat' | translate}}"
                       maxlength="10" (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)">
                <div class="input-group-append disable-on-fieldset" (click)="!dpWorkflowStartDate.isDisabled && dpWorkflowStartDate.toggle()">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="icon-calendar" data-testid="workflowStartDateIniCalendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col datepicker-box">
            <div class="form-group">
              <div class="input-group">
                <div style="padding-right:5px; padding-top:10px;">
                  <label for="workflowStartDateFim"> a </label>
                </div>
                <input #dpWorkflowEndDate="bsDatepicker" bsDatepicker type="text" class="form-control DatepickerCustomClasse"
                       [disabled]="workflowStartDateIni == null"
                       [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                       [minDate]="workflowStartDateIni"
                       [(ngModel)]="workflowStartDateFim"
                       name="workflowStartDateFim" placeholder=" {{'Placeholders.Generic.DateFormat' | translate}}"
                       maxlength="10" (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpWorkflowEndDate)" />
                <div class="input-group-append disable-on-fieldset" (click)="!dpWorkflowEndDate.isDisabled && dpWorkflowEndDate.toggle()">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="icon-calendar" data-testid="workflowStartDateFimCalendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Data de Validação do Pedido -->
      <div class="col-xl-4 col-md-6 label_margin">
        <h3> {{'InstanceBrowser.WorkflowValidateDate' | translate}} </h3>
        <div class="row">
          <div class="col datepicker-box">
            <div class="form-group">
              <div class="input-group">
                <div style="padding-right:5px; padding-top:10px;">
                  <label for="workflowValidateDateIni"> De </label>
                </div>
                <input #dpWorkflowValidateStartDate="bsDatepicker" bsDatepicker type="text" class="form-control DatepickerCustomClasse"
                       [clearRelated]="{model : this, propsToReset : ['workflowValidateDateFim']}"
                       [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                       [(ngModel)]="workflowValidateDateIni"
                       name="workflowValidateDateIni" placeholder=" {{'Placeholders.Generic.DateFormat' | translate}}"
                       maxlength="10" (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)">
                <div class="input-group-append disable-on-fieldset" (click)="!dpWorkflowValidateStartDate.isDisabled && dpWorkflowValidateStartDate.toggle()">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="icon-calendar" data-testid="workflowValidateDateIniCalendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col datepicker-box">
            <div class="form-group">
              <div class="input-group">
                <div style="padding-right:5px; padding-top:10px;">
                  <label for="workflowValidateDateFim"> a </label>
                </div>
                <input #dpWorkflowValidateEndDate="bsDatepicker" bsDatepicker type="text" class="form-control DatepickerCustomClasse"
                       [disabled]="workflowValidateDateIni == null"
                       [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                       [(ngModel)]="workflowValidateDateFim"
                       [minDate]="workflowValidateDateIni"
                       name="workflowValidateDateFim" placeholder=" {{'Placeholders.Generic.DateFormat' | translate}}"
                       maxlength="10" (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpWorkflowValidateEndDate)" />
                <div class="input-group-append disable-on-fieldset" (click)="!dpWorkflowValidateEndDate.isDisabled && dpWorkflowValidateEndDate.toggle()">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="icon-calendar" data-testid="workflowValidateDateFimCalendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Data de Submissão do Pedido -->
      <div class="col-xl-4 col-md-6 label_margin">
        <h3> {{'InstanceBrowser.WorkflowSubmitDate' | translate}} </h3>
        <div class="row">
          <div class="col datepicker-box">
            <div class="form-group">
              <div class="input-group">
                <div style="padding-right:5px; padding-top:10px;">
                  <label for="workflowSubmitDateIni"> De </label>
                </div>
                <input #dpWorkflowSubmitStartDate="bsDatepicker" bsDatepicker type="text" class="form-control DatepickerCustomClasse"
                       [clearRelated]="{model : this, propsToReset : ['workflowSubmitDateFim']}"
                       [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                       [(ngModel)]="workflowSubmitDateIni"
                       name="workflowSubmitDateIni" placeholder=" {{'Placeholders.Generic.DateFormat' | translate}}"
                       maxlength="10" (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)">
                <div class="input-group-append disable-on-fieldset" (click)="!dpWorkflowSubmitStartDate.isDisabled && dpWorkflowSubmitStartDate.toggle()">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="icon-calendar" data-testid="workflowSubmitDateIniCalendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col datepicker-box">
            <div class="form-group">
              <div class="input-group">
                <div style="padding-right:5px; padding-top:10px;">
                  <label for="workflowSubmitDateFim"> a </label>
                </div>
                <input #dpWorkflowSubmitEndDate="bsDatepicker" bsDatepicker type="text" class="form-control DatepickerCustomClasse"
                       [disabled]="workflowSubmitDateIni == null"
                       [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD',containerClass: 'theme-default', showWeekNumbers:false }"
                       [(ngModel)]="workflowSubmitDateFim"
                       [minDate]="workflowSubmitDateIni"
                       name="workflowSubmitDateFim" placeholder=" {{'Placeholders.Generic.DateFormat' | translate}}"
                       maxlength="10" (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpWorkflowSubmitEndDate)" />
                <div class="input-group-append disable-on-fieldset" (click)="!dpWorkflowSubmitEndDate.isDisabled && dpWorkflowSubmitEndDate.toggle()">
                  <span class="input-group-text" id="basic-addon2">
                    <i class="icon-calendar" data-testid="workflowSubmitDateFimCalendar"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </form>

  <!-- Pesquisa -->
  <div class="btn-group search-button" *ngIf="isService || isAtendimento">
    <button type="button" class="btn btn-secondary toggle-split" (click)="showHide()" *ngIf="!isArrowUp">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-arrow-bar-up" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M8 10a.5.5 0 0 0 .5-.5V3.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 3.707V9.5a.5.5 0 0 0 .5.5zm-7 2.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5z" />
      </svg>
    </button>
    <button type="button" class="btn btn-secondary" (click)="searchData()" style="margin-left: 0.3rem">
      {{'InstanceBrowser.WorkflowSeach' | translate}}
    </button>
    <button type="button" class="btn btn-secondary" (click)="clearData()" *ngIf="!bottonClear" style="margin-left: 0.3rem">
      {{'InstanceBrowser.ClearData' | translate}}
    </button>
    <button type="button" class="btn btn-secondary" (click)="exportData()" style="margin-left: 0.3rem">
      Exportar
    </button>
  </div>

  <!-- Atendimento -->
  <div *ngIf="isAtendimento">
    <table class="table table-striped" data-testid="tableAtendimento">
      <thead>
        <tr>
          <th scope="col">{{'InstanceBrowser.SubscriberNumber' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.SubscriberName' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.ServiceName' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.InstanceType' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.InstanceStatus' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.Pedido' | translate}}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let instance of instances.instances;let i = index">
          <tr [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
            <td>
              <ng-container *ngIf="instance.workflowReason.toLowerCase().includes('ex-subscritor') || instance.workflowType.toLowerCase().includes('ex-subscritor') ;else normalSubscriber ">
                <div class="row">
                  <div class="col-md-2">
                    <span placement="top" [tooltip]="'InstanceBrowser.SubscriberTypeExSubscriber' | translate" class="icon-user" style="color: #CCC; position: relative; top: 0; left: 0"></span>
                    <span class="exsubscritores-icon">\</span>

                  </div>
                  <span class="col-md-9">{{instance.subscriberNumber}}</span>
                </div>
                <!--<span class="icon-close"  style="font-size:6px;color: var(--red); position: relative; top: 1px; left: -4px"></span>-->
              </ng-container>
              <ng-template #normalSubscriber>
                <div class="row">
                  <div class="col-md-2">
                    <span class="icon-user subscritores-icon" [tooltip]="'InstanceBrowser.SubscriberTypeSubscriber' | translate" style="color: #3391ff; position: relative; top: 0; left: 0"></span>

                  </div>
                  <span class="col-md-9">{{instance.subscriberNumber}}</span>
                </div>

              </ng-template>

            </td>
            <td>{{instance.subscriberName}}</td>
            <td>{{getServiceName(instance)}}</td>
            <td>{{getInstanceTypeText(instance)}}</td>
            <!--UNCOMMENT NEXT LINE AND COMMENT THE LINE BELOW TO ACTIVATE TOOLTIPS-->
            <!--<td container="element" placement="top" [tooltip]="instance.fullPediPhaseTooltip">{{instance.fullPediPhaseDesc}}</td>-->
            <td>{{ getEstado(instance) + ' | ' + instance.fullPediPhaseDesc }}</td>
            <td>
              <div>
                <div *ngIf="isVisibilityOnAtendimento(instance)">

                  <span class="icon-doc access-request-text"
                        [ngClass]="allowInstanceAccess(instance) ? null : 'disabled'"
                        (click)="navigateToInstance(instance,$event)"></span>
                  <span class="access-request-text " [ngClass]="allowInstanceAccess(instance) ? null : 'disabled'"
                        (click)="navigateToInstance(instance,$event)">
                    {{'InstanceBrowser.Access' | translate}}
                  </span>
                </div>

                <div *ngIf="awaitingManifest(instance) && (instance.instancePhase === 'AIC' || instance.instancePhase === 'PCS')">
                  <span class="icon-doc access-request-text" (click)="navigateToReadonlyPrestage(instance,$event)"></span>
                  <span class="access-request-text " (click)="navigateToReadonlyPrestage(instance,$event)">
                    {{'InstanceBrowser.Access' | translate}}
                  </span>
                </div>

                <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação"
                      *ngIf="(!allowInstanceAccess(instance) && instance.instanceStatus == 'R')"
                      tooltip="{{(instance.workflowType.indexOf('Contagem') ===-1 ? 'Tooltips.InstanceBrowser.NotAuthorizedRegisted' : 'Tooltips.InstanceBrowser.NotAuthorizedRegistedCT') | translate}}"></span>
                <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação" *ngIf="(!allowInstanceAccess(instance) && instance.instanceStatus == 'P')"
                      tooltip="{{(instance.workflowType.indexOf('Contagem') ===-1 ? 'Tooltips.InstanceBrowser.NotAuthorizedPendent' : 'Tooltips.InstanceBrowser.NotAuthorizedPendentCT') | translate}}"></span>
                <span tabindex="0" class="ml-1 text-primary icon-help" aria-label="Tooltip com informação"
                      *ngIf="(!allowInstanceAccess(instance) && instance.instanceStatus == 'I')"
                      tooltip="{{(instance.workflowType.indexOf('Prestações por morte') !==-1 ? 'Tooltips.InstanceBrowser.NotAuthorizedInvalidPM' : instance.workflowType.indexOf('Contagem') !==-1 ? 'Tooltips.InstanceBrowser.NotAuthorizedInvalidCT' : 'Tooltips.InstanceBrowser.NotAuthorizedInvalid') | translate}}"></span>
              </div>
            </td>
            <td class="single-buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
              <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
                <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : 'text-primary icon-more'"></span>
              </button>
            </td>
          </tr>
          <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
            <td class="p-0" colspan="7" id="collapseBasic">
              <div class="ml-5 mr-5 p-4">
                <instance-browser-detail [item]="instance"></instance-browser-detail>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tr *ngIf="instances.instances.length === 0">
        <td style="cursor: default;position: relative;left: 40%;">{{'InstanceBrowser.NoDataFound' | translate}}</td>
      </tr>
    </table>
  </div>

  <!-- Serviço -->
  <div *ngIf="isService">
    <table class="table table-striped" data-testid="tableServico">
      <thead>
        <tr>
          <th scope="col">{{'InstanceBrowser.SubscriberNumber' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.SubscriberName' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.InstanceType' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.InstanceStatus' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.Pedido' | translate}}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let instance of instances.instances;let i = index">
          <tr [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
            <td>
              <ng-container *ngIf="instance.workflowReason.toLowerCase().includes('ex-subscritor') || instance.workflowType.toLowerCase().includes('ex-subscritor') ;else normalSubscriber ">
                <div class="row">
                  <div class="col-md-2">
                    <span placement="top" [tooltip]="'InstanceBrowser.SubscriberTypeExSubscriber' | translate" class="icon-user" style="color: #CCC; position: relative; top: 0; left: 0"></span>
                    <span class="exsubscritores-icon">\</span>

                  </div>
                  <span class="col-md-9">{{instance.subscriberNumber}}</span>
                </div>
                <!--<span class="icon-close"  style="font-size:6px;color: var(--red); position: relative; top: 1px; left: -4px"></span>-->
              </ng-container>
              <ng-template #normalSubscriber>
                <div class="row">
                  <div class="col-md-2">
                    <span class="icon-user subscritores-icon" [tooltip]="'InstanceBrowser.SubscriberTypeSubscriber' | translate" style="color: #3391ff; position: relative; top: 0; left: 0"></span>

                  </div>
                  <span class="col-md-9">{{instance.subscriberNumber}}</span>
                </div>

              </ng-template>
            </td>
            <td>{{instance.subscriberName}}</td>
            <td>{{getInstanceTypeText(instance)}}</td>
            <!--UNCOMMENT NEXT LINE AND COMMENT THE LINE BELOW TO ACTIVATE TOOLTIPS-->
            <!--<td container="element" placement="top" [tooltip]="instance.fullPediPhaseTooltip">{{instance.fullPediPhaseDesc}}</td>-->
            <td>{{ getEstado(instance) + ' | ' + instance.fullPediPhaseDesc}}</td>
            <td>
              <div>
                <span class="icon-doc access-request-text" [ngClass]="allowInstanceAccess(instance) ? null : 'disabled'" (click)="navigateToInstance(instance,$event)"></span>
                <span class="access-request-text " [ngClass]="allowInstanceAccess(instance) ? null : 'disabled'" (click)="navigateToInstance(instance,$event)">{{'InstanceBrowser.Access' | translate}}</span>
              </div>
            </td>
            <td class="single-buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
              <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
                <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : 'text-primary icon-more'"></span>
              </button>
            </td>
          </tr>
          <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
            <td class="p-0" colspan="7" id="collapseBasic">
              <div class="ml-5 mr-5 p-4">
                <instance-browser-detail [item]="instance"></instance-browser-detail>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tr *ngIf="instances.instances.length === 0">
        <td style="cursor: default;position: relative;left: 40%;">{{'InstanceBrowser.NoDataFound' | translate}}</td>
      </tr>
    </table>
  </div>

  <!-- Subscritor -->
  <div *ngIf="!isService && !isAtendimento">
    <table class="table table-striped" data-testid="tableSubscritor">
      <thead>
        <tr>
          <th scope="col">{{'InstanceBrowser.InstanceType' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.DateBegin' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.DateEnd' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.Status' | translate}}</th>
          <th scope="col">{{'InstanceBrowser.Pedido' | translate}}</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let instance of instances.instances;let i = index">
          <tr [ngClass]="expandedRowIndex == i  ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
            <td>{{getInstanceTypeText(instance)}}</td>
            <td>{{getDateText(instance.instanceCreationDate)}}</td>
            <td>{{getDateText(instance.instanceExpireDate)}}</td>
            <!--UNCOMMENT NEXT LINE AND COMMENT THE LINE BELOW TO ACTIVATE TOOLTIPS-->
            <!--<td container="element" placement="top" [tooltip]="instance.fullPediPhaseTooltip">{{instance.fullPediPhaseDesc}}</td>-->
            <td>{{ getEstado(instance) + ' | ' + instance.fullPediPhaseDesc}}</td>

            <td>
              <div *ngIf="awaitingManifest(instance) && instance.instancePhase!='DS' && instance.instancePhase!='PNS' && instance.instancePhase!='PCS' && instance.instancePhase != 'AIC'  && instance.instancePhase != 'PVR' && instance.instancePhase != 'PCR'">
                <span class="icon-doc access-request-text" [ngClass]="allowInstanceAccess(instance) ? null : 'disabled'" (click)="navigateToInstanceManifest(instance,$event)"></span>
                <span class="access-request-text " [ngClass]="allowInstanceAccess(instance) ? null : 'disabled'" (click)="navigateToInstanceManifest(instance,$event)">
                  {{'InstanceBrowser.Manifest' | translate}}
                </span>
              </div>
              <div *ngIf="awaitingManifest(instance) &&  (instance.instancePhase == 'PVR' || instance.instancePhase == 'DR' )">
                <span class="icon-doc access-request-text" (click)="navigateToReadonlyPrestagePM(instance,$event)"></span>
                <span class="access-request-text " (click)="navigateToReadonlyPrestagePM(instance,$event)">
                  {{'InstanceBrowser.VisualizarPedido' | translate}} 
                </span>
              </div>
              <div *ngIf="awaitingManifest(instance) && instance.instanceStatus=='P' && instance.instancePhase == 'AIC'">
                <span class="icon-doc access-request-text" (click)="navigateToReadonlyPrestage(instance,$event)"></span>
                <span class="access-request-text " (click)="navigateToReadonlyPrestage(instance,$event)">
                  {{'InstanceBrowser.VisualizarPedido' | translate}}
                </span> 
              </div>
              <div *ngIf="awaitingManifest(instance) && instance.instanceStatus=='P' && instance.instancePhase == 'PCS'">
                <span class="icon-doc access-request-text" (click)="navigateToReadonlyPrestage(instance,$event)"></span>
                <span class="access-request-text " (click)="navigateToReadonlyPrestage(instance,$event)">
                  {{'InstanceBrowser.VisualizarPedido' | translate}}
                </span>
              </div>
              <div *ngIf="!awaitingManifest(instance) || (instance.instanceStatus=='P' && instance.instancePhase=='PNS') || (instance.instanceStatus=='P' && instance.instancePhase=='DS')  || (instance.instanceStatus=='I' && instance.instancePhase=='RLI')">
                <span class="icon-doc access-request-text" [ngClass]="allowInstanceAccess(instance) ? null : 'disabled'" (click)="navigateToInstance(instance,$event)"></span>
                <span class="access-request-text " [ngClass]="allowInstanceAccess(instance) ? null : 'disabled'" (click)="navigateToInstance(instance,$event)">
                  {{'InstanceBrowser.Access' | translate}}
                </span>
              </div>

            </td>

            <td class="single-buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
              <button type="button" *ngIf="instance.instanceStatus == 'P' && (instance.instancePhase=='PNS' || instance.instancePhase=='DS')" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
                <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' : 'text-primary icon-more'"></span>
              </button>
            </td>
          </tr>
          <tr *ngIf="expandedRowIndex == i && instance.instanceStatus == 'P' && (instance.instancePhase=='PNS' || instance.instancePhase=='DS')" [collapse]="expandedRowIndex != i" [isAnimated]="false">
            <td class="p-0" colspan="7" id="collapseBasic">
              <div class="ml-5 mr-5 p-4" *ngIf="instance.instancePhase=='PNS'">
                <p class="text-secondary">{{'WorkflowCreate.ContagemTempoExSubs.DevolutionTitle' | translate}}</p>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="RejectionReason" class="date-detail-header">{{'WorkflowCreate.ContagemTempoExSubs.DevolutionReason' | translate}}</label>
                      <p class="date-detail-value">{{instance.nokReason}}&nbsp;</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ml-5 mr-5 p-4" *ngIf="instance.instancePhase=='DS'">
                <p class="text-secondary">{{'WorkflowCreate.ContagemTempoExSubs.DevolutionTitle' | translate}}</p>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label for="RejectionReason" class="date-detail-header">{{'WorkflowCreate.ContagemTempoExSubs.DevolutionCGAReason' | translate}}</label>
                      <p class="date-detail-value">{{instance.nokcgaReason!='null'?instance.nokcgaReason:''}}&nbsp;</p>
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tr *ngIf="instances.instances.length === 0">
        <td style="cursor: default;position: relative;left: 40%;">{{'InstanceBrowser.NoDataFound' | translate}}</td>
      </tr>
    </table>
  </div>


  <!--LEGENDA-->
  <!--<div class="row" *ngIf="instances.instances?.length>0" style="border-top: 2px solid #3391FF; padding: 4px; margin: 8px;">
    <div class="col-md-1">
      <label class="form-check-label" for="voluntaria" style="user-select: none;">
        {{'InstanceBrowser.Legenda' | translate}}
      </label>
    </div>
    <div class="col-md-2">
      <div class="row">
        <div class="col-md-2">
          <span class="icon-user" style="color: #3391ff; position: relative; top: 0; left: 0"></span>
        </div>
        <span class="col-md-10" data-testid="legendaSubscritor" style="color: #3391ff; font-size: 80%;">{{'InstanceBrowser.SubscriberTypeSubscriber' | translate}}</span>
      </div>
      <div class="row">
        <div class="col-md-2">
            <span class="icon-user " style="color: #CCC; position: relative; top: 0; left: 0"></span>
            <span style="color: #AAA; position: relative; top: -1px; left: -10px">\</span>
        </div>

        <span class="col-md-10" data-testid="legendaExSubscritor" style="color:#AAA;font-size:80%;">{{'InstanceBrowser.SubscriberTypeExSubscriber' | translate}}</span>

      </div>


    </div>
  </div>-->
  <!-- Modals -->
  <ng-template #warning>
    <div class="modal-header">
      <h5 class="modal-title text-warning d-flex align-items-center">
        <span class="icon-warning mr-2 ft-sz-24"></span>
        {{'WorkflowCreate.WithDraftTitle' | translate}}
      </h5>
      <button type="button" class="close pull-right" aria-label="Fechar" (click)="modalRef.hide()" name="warning">
        <span aria-hidden="true" class="icon-close"></span>
      </button>
    </div>
    <div class="modal-body">
      {{instances.message}}
    </div>
  </ng-template>

  <ng-template #empty>
    <div class="modal-header">
      <h5 class="modal-title text-warning d-flex align-items-center">
        <span class="icon-warning mr-2 ft-sz-24"></span>
        {{'WorkflowCreate.WithDraftTitle' | translate}}
      </h5>
      <button type="button" class="close pull-right" aria-label="Fechar" (click)="modalRef.hide()" name="empty">
        <span aria-hidden="true" class="icon-close"></span>
      </button>
    </div>
    <div class="modal-body">
      {{'InstanceBrowser.EmptyData' | translate}}
    </div>
  </ng-template>

</div>
